/**
 * [BLURY] | 🥭 Rail
 * The control column — every panel in pipeline order.
 * @build 13.09.26
 * @updated 13.09.26 PHT
 * @author TONYTONY Sàrl
 */
import { BlurPanel } from './panels/BlurPanel';
import { ExportPanel } from './panels/ExportPanel';
import { GrainPanel } from './panels/GrainPanel';
import { RatioPanel } from './panels/RatioPanel';
import { ShapePanel } from './panels/ShapePanel';
import styles from './Rail.module.css';

export function Rail() {
  return (
    <aside className={styles.rail}>
      <div className={styles.head}>
        <h1>
          Grain <em>Field</em>
        </h1>
        <p>shapes → gaussian blur → grain</p>
      </div>

      <div className={styles.scroll}>
        <RatioPanel />
        <ShapePanel />
        <BlurPanel />
        <GrainPanel />
        <ExportPanel />
      </div>
    </aside>
  );
}
